export default {
  toAmethyst: () => import('../showcase/amethyst.json'),
  toTopaz: () => import('./amethyst-topaz.json'),
  toAquamarine: () => import('./topaz-aquamarine.json'),
  toOpal: () => import('./aquamarine-opal.json'),
  toEmerald: () => import('./opal-emerald.json'),
  toRuby: () => import('./emerald-ruby.json'),
  toSapphire: () => import('./ruby-sapphire.json'),
  toDiamond: () => import('./sapphire-diamond.json'),
  toVip: () => import('../showcase/vip.json'),
};
